import { GameCategory, LabelType, ProviderName } from "@/types";
import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from "date-fns";
import { toast } from "react-toastify";

export const formatText = (text: string, length: number, suffix = "...") => {
  try {
    if (text.length <= length) return text;
    return text.substring(0, length) + suffix;
  } catch {
    return text;
  }
};

export const PREDICTION_GAME_TYPE = {
  BTCUSD: "BTC-USD",
  BNBUSD: "BNB-USD",
  ETHUSD: "ETH-USD",
};

export const handleCopy = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success("Copied to clipboard!");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};

const categoryLabels: Record<GameCategory, string> = {
  LIVE_CASINO: "Live Casino",
  SLOTS: "Slots",
  SIDE_BETS: "Side Bets",
  MINI_GAMES: "Mini Games",
  BATTLES: "Battles",
  ORIGINAL: "Original Games",
};

const providerLabels: Record<ProviderName, string> = {
  BARBARA: "Barbara",
  CREEDROOMZ: "Creedroomz",
  PASCAL: "Pascal",
  POPOK: "PopOk",
  PopOkGames: "PopOk Games",
  SHARKROLL: "Sharkroll",
  SUMMUS: "Summus",
  TADA: "Tada Gaming",
  BPG: "Blueprint Games",
  EVO: "Evolution Games",
  HAK: "Hacksaw Games",
  TK: "ThunderKick Games",
  NLC: "No Limit City Games",
  CQC: "CQ9 Games",
  SM: "Slot Mill Games",
  DS: "Dragon Soft Games",
  CLW: "Claw Buster Games",
  "1x2": "1x2 Games",
};

export const formatLabel = (value: string, type: LabelType): string => {
  if (type === "category") {
    return categoryLabels[value as GameCategory] ?? value;
  } else if (type === "provider") {
    return providerLabels[value as ProviderName] ?? value;
  }
  return value;
};

export const getPresetDate = (
  preset: "day" | "week" | "month" | "year",
): { startDate: Date; endDate: Date } => {
  switch (preset) {
    case "day":
      return {
        startDate: startOfDay(new Date()),
        endDate: endOfDay(new Date()),
      };
    case "week":
      return {
        startDate: startOfWeek(new Date()),
        endDate: endOfWeek(new Date()),
      };
    case "month":
      return {
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date()),
      };
    case "year":
      return {
        startDate: startOfYear(new Date()),
        endDate: endOfYear(new Date()),
      };

    default:
      return {
        startDate: new Date(),
        endDate: new Date(),
      };
  }
};
